import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationService } from './services/notification.service';
import { AppVersionService } from './services/app-version.service';

// A tab opened before a deploy asks for chunks the new container no longer has (Chrome, Safari, Firefox wording).
const CHUNK_LOAD_FAILURE =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private notificationService = inject(NotificationService);
  private appVersionService = inject(AppVersionService);
  private transloco = inject(TranslocoService);
  private zone = inject(NgZone);

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      console.error(
        'HTTP error caught by GlobalErrorHandler (should be handled by Interceptor):',
        error,
      );
      return;
    }

    if (error instanceof Error && CHUNK_LOAD_FAILURE.test(error.message)) {
      this.zone.run(() => this.appVersionService.promptReload());
      return;
    }

    console.error('Caught by GlobalErrorHandler:', error);

    this.zone.run(() => {
      this.notificationService.show(
        this.transloco.translate('errors.generic'),
      );
    });
  }
}
